<div class='barra' role='footer'>
</div>

<mat-accordion class="hidden-footer-mobile" multi>
    <mat-expansion-panel class="expansive-panel">
        <mat-expansion-panel-header>
            <mat-panel-title>
                O que você precisa?
            </mat-panel-title>
        </mat-expansion-panel-header>
        <ul>
            <li>
                <a title="Consultar meu CPF" href="https://www.serasa.com.br/consultar-meu-cpf/">Consultar meu
                    CPF</a>
            </li>
            <li>
                <a title="Pedir empréstimo online" href="https://www.serasa.com.br/ecred">Pedir empréstimo
                    online</a>
            </li>
            <li>
                <a title="Limpar meu nome" href="https://www.serasa.com.br/limpa-nome-online/">Limpar meu nome</a>
            </li>
            <li>
                <a title="Consultar pontuação do Score" href="https://www.serasa.com.br/score/">Consultar pontuação
                    do
                    Score</a>
            </li>
            <li>
                <a title="Negociar minhas dívidas" href="https://www.serasa.com.br/limpa-nome-online/">Negociar
                    minhas
                    dívidas</a>
            </li>
            <li>
                <a title="Monitorar meu CPF" href="https://www.serasa.com.br/antifraude/">Monitorar meu CPF</a>
            </li>
            <li>
                <a title="Falar com a Serasa" href="https://www.serasa.com.br/atendimento/">Falar com a Serasa</a>
            </li>
            <li>
                <a title="Atualizar meus dados"
                    href="https://www.serasa.com.br/outros-servicos/atualizacao_de_cadastro/">Atualizar meus
                    dados</a>
            </li>
            <li>
                <a title="Soluções para empresas" href="https://www.serasaexperian.com.br">Soluções para
                    empresas</a>
            </li>
        </ul>
    </mat-expansion-panel>

    <mat-expansion-panel class="expansive-panel">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Todos os sites
            </mat-panel-title>
        </mat-expansion-panel-header>
        <ul>
            <li>
                <a title="Serasa eCred" href="https://www.serasa.com.br/ecred/">Serasa eCred</a>
            </li>
            <li>
                <a title="Serasa AntiFraude" href="https://www.serasa.com.br/antifraude/">Serasa AntiFraude</a>
            </li>
            <li>
                <a title="Serasa Score" href="https://www.serasa.com.br/score/">Serasa Score</a>
            </li>
            <li>
                <a title="Serasa Limpa Nome" href="https://www.serasa.com.br/limpa-nome-online/">Serasa Limpa
                    Nome</a>
            </li>
            <li>
                <a title="Serasa Cadastro Positivo" href="https://www.serasa.com.br/optin/">Serasa Cadastro
                    Positivo</a>
            </li>
            <li>
                <a title="Serasa Ensina" href="https://www.serasa.com.br/ensina/">Serasa Ensina</a>
            </li>
        </ul>
    </mat-expansion-panel>

    <mat-expansion-panel class="expansive-panel">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Atendimento
            </mat-panel-title>
        </mat-expansion-panel-header>
        <ul>
            <li>
                <a title="Pontos de Atendimento" href="https://www.serasa.com.br/sc-atendimento/agencias/">Pontos de
                    Atendimento</a>
            </li>
            <li>
                <a title="Telefones" href="https://www.serasa.com.br/atendimento">Telefones</a>
            </li>
            <li>
                <a title="Central de Ajuda" href="https://ajuda.serasaconsumidor.com.br/">Central de Ajuda</a>
            </li>
        </ul>
    </mat-expansion-panel>

    <mat-expansion-panel class="expansive-panel">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Outros Serviços
            </mat-panel-title>
        </mat-expansion-panel-header>
        <ul>
            <li>
                <a title="Atualizar meus dados"
                    href="https://www.serasa.com.br/outros-servicos/atualizacao_de_cadastro/">Atualizar meus dados</a>
            </li>
            <li>
                <a title="Como consultar seu CPF" href="https://www.serasa.com.br/consultar-meu-cpf/">Como consultar seu
                    CPF</a>
            </li>
            <li>
                <a title="Proteger meus documentos"
                    href="https://www.serasa.com.br/documentos-perdidos-roubados/">Proteger
                    meus documentos</a>
            </li>
            <li>
                <a title="Carta comunicado" href="https://www.serasa.com.br/carta-serasa-experian/">Carta comunicado</a>
            </li>
            <li>
                <a title="Empresas que consultam meu CPF"
                    href="https://www.serasa.com.br/consultas-ao-meu-cpf/">Empresas
                    que consultam meu CPF</a>
            </li>
        </ul>
    </mat-expansion-panel>
</mat-accordion>

<div class="container">
    <div class="row hidden-footer">
        <div class="col-sm">
            <ul>
                <li class="title">O que você precisa?</li>
                <li>
                    <a title="Consultar meu CPF" href="https://www.serasa.com.br/consultar-meu-cpf/">Consultar meu
                        CPF</a>
                </li>
                <li>
                    <a title="Pedir empréstimo online" href="https://www.serasa.com.br/ecred">Pedir empréstimo
                        online</a>
                </li>
                <li>
                    <a title="Limpar meu nome" href="https://www.serasa.com.br/limpa-nome-online/">Limpar meu nome</a>
                </li>
                <li>
                    <a title="Consultar pontuação do Score" href="https://www.serasa.com.br/score/">Consultar pontuação
                        do Score</a>
                </li>
                <li>
                    <a title="Negociar minhas dívidas" href="https://www.serasa.com.br/limpa-nome-online/">Negociar
                        minhas dívidas</a>
                </li>
                <li>
                    <a title="Monitorar meu CPF" href="https://www.serasa.com.br/antifraude/">Monitorar meu CPF</a>
                </li>
                <li>
                    <a title="Falar com a Serasa" href="https://www.serasa.com.br/atendimento/">Falar com a Serasa</a>
                </li>
                <li>
                    <a title="Atualizar meus dados"
                        href="https://www.serasa.com.br/outros-servicos/atualizacao_de_cadastro/">Atualizar meus
                        dados</a>
                </li>
                <li>
                    <a title="Soluções para empresas" href="https://www.serasaexperian.com.br">Soluções para
                        empresas</a>
                </li>
            </ul>
        </div>
        <div class="col-sm">
            <ul>
                <li class="title">Todos os sites</li>
                <li>
                    <a title="Serasa eCred" href="https://www.serasa.com.br/ecred/">Serasa eCred</a>
                </li>
                <li>
                    <a title="Serasa AntiFraude" href="https://www.serasa.com.br/antifraude/">Serasa AntiFraude</a>
                </li>
                <li>
                    <a title="Serasa Score" href="https://www.serasa.com.br/score/">Serasa Score</a>
                </li>
                <li>
                    <a title="Serasa Limpa Nome" href="https://www.serasa.com.br/limpa-nome-online/">Serasa Limpa
                        Nome</a>
                </li>
                <li>
                    <a title="Serasa Cadastro Positivo" href="https://www.serasa.com.br/cadastro-positivo/">Serasa
                        Cadastro Positivo</a>
                </li>
                <li>
                    <a title="Serasa Ensina" href="https://www.serasa.com.br/ensina/">Serasa Ensina</a>
                </li>
            </ul>
        </div>
        <div class="col-sm">
            <ul>
                <li class="title">Atendimento</li>
                <li>
                    <a title="Pontos de Atendimento" href="https://www.serasa.com.br/sc-atendimento/agencias/">Pontos de
                        Atendimento</a>
                </li>
                <li>
                    <a title="Telefones" href="https://www.serasa.com.br/atendimento">Telefones</a>
                </li>
                <li>
                    <a title="Central de Ajuda" href="https://ajuda.serasaconsumidor.com.br/">Central de Ajuda</a>
                </li>
            </ul>
        </div>
        <div class="col-sm">
            <ul>
                <li class="title">Outros Serviços</li>
                <li>
                    <a title="Atualizar meus dados"
                        href="https://www.serasa.com.br/outros-servicos/atualizacao_de_cadastro/">Atualizar meus
                        dados</a>
                </li>
                <li>
                    <a title="Como consultar seu CPF" href="https://www.serasa.com.br/consultar-meu-cpf/">Como consultar
                        seu CPF</a>
                </li>
                <li>
                    <a title="Proteger meus documentos"
                        href="https://www.serasa.com.br/documentos-perdidos-roubados/">Proteger meus documentos</a>
                </li>
                <li>
                    <a title="Carta comunicado" href="https://www.serasa.com.br/carta-serasa-experian/">Carta
                        comunicado</a>
                </li>
                <li>
                    <a title="Empresas que consultam meu CPF"
                        href="https://www.serasa.com.br/consultas-ao-meu-cpf/">Empresas que consultam meu CPF</a>
                </li>
            </ul>
        </div>
    </div>
    <div class="row">
        <div class="modal-footer" style="width: 100%;"></div>
    </div>
    <div class="row">
        <div class="col-sm div-social">
            <span class="col-3 link social-icons" onclick="location='https://www.facebook.com/serasa.com.br'"><i
                    class="fa fa-facebook-official fa-2x" aria-hidden="true"></i></span>
            <span class="col-3 link social-icons" onclick="location='https://www.youtube.com/SerasaConsumidor'"><i
                    class="fa fa-youtube-play fa-2x" aria-hidden="true"></i></span>
            <span class="col-3 link social-icons" onclick="location='https://www.instagram.com/serasa/'"><i
                    class="fa fa-instagram fa-2x" aria-hidden="true"></i></span>
            <span class="col-3 link social-icons"
                onclick="location='https://www.linkedin.com/company/serasaconsumidor'"><i
                    class="fa fa-linkedin-square fa-2x" aria-hidden="true"></i></span>
        </div>
        <div class="col-sm div-social">

            <a href='https://play.google.com/store/apps/details?id=br.com.serasaexperian.consumidor'><img
                    alt='Disponível no Google Play' src='assets/google-play-store.svg' /></a>
            <a href='https://itunes.apple.com/br/app/serasaconsumidor/id1102452668?mt=8'><img
                    alt='Disponível na Apple Store' src='assets/app_store_badge.svg' /></a>

        </div>
        <div class="col-sm div-social">
            <a href="https://globalsign.ssllabs.com/analyze.html?d=www.serasa.com.br"><img alt="SSL" id="ss_img"
                    src="assets/serasa_experian_global_sign.svg"></a>
        </div>
    </div>
</div>